<template>
  <div class="main-dashboard-header-wrapper">
    <div class="dashboard-header clearfix">
      <div class="filter-part fa-pull-left">
        <label class="control-label control-label-default">
          {{ $t('DASHBOARD.headerFilter.selectTeam')}}
        </label>
        <b-dropdown class="btn-group dropdown dashboard-filter-btn dropdown-btn-group" menu-class="teams-dropdown">
          <template slot="button-content">
            <template v-if="selectedEntity === ENTITIES.TEAM && selectedTeam && selectedTeam.teamId">
              <span class="text-ellipsis-overflow">
                {{selectedTeam.teamName}}
              </span>
            </template>
            <template v-if="selectedEntity === ENTITIES.ALL_TEAMS">
              <span class="text-ellipsis-overflow">
                {{ $t('DASHBOARD.headerFilter.allTeams')}}
              </span>
            </template>

            <template v-if="selectedEntity === ENTITIES.INDIVIDUAL">
              <span class="text-ellipsis-overflow">
                {{ $t('DASHBOARD.headerFilter.individual')}}
              </span>
            </template>
          </template>

          <b-dropdown-item
            :class="{ active: selectedEntity === ENTITIES.ALL_TEAMS }"
            @click.prevent="selectAllTeamsAndLog">{{ $t('DASHBOARD.headerFilter.allTeams')}}</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>

          <b-dropdown-item
            :class="{ active: selectedEntity === ENTITIES.INDIVIDUAL }"
            @click.prevent="selectIndividualAndLog">{{ $t('DASHBOARD.headerFilter.individual')}}</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>

          <template v-if="teams.length">
            <b-dropdown-item
              v-for="(team, i) in teams"
              :key="i"
              @click.prevent="onSelectingTeamAndLog(team.teamId)"
              :class="{ active: (selectedEntity === ENTITIES.TEAM && selectedTeam && team.teamId === selectedTeam.teamId) }">

              <span class="text-ellipsis-overflow">{{team.teamName}}</span>
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </div>
    
      <div :class="`filter-part dates-filter fa-pull-right ${selectedTimeRange.value === TIME_RANGE.CUSTOM.value ? 'custom-dates-selected' : ''}`">
         <b-button-group class="switch-btn-group mr-25px">
            <b-button 
               :class="{ active: selectedTimeRange.value === TIME_RANGE.SESSION.value }" 
               @click="changeTimeRangeAndLog(TIME_RANGE.SESSION.value)">
               {{ $t('DASHBOARD.headerFilter.lastSession') }}
            </b-button>
         </b-button-group>
        <b-button-group class="switch-btn-group">
          
          <b-button 
            :class="{ active: selectedTimeRange.value === TIME_RANGE.WEEK.value }" 
            @click="changeTimeRangeAndLog(TIME_RANGE.WEEK.value)">
            {{ $t('DASHBOARD.headerFilter.last7days') }}
          </b-button>
          <b-button 
            :class="{ active: selectedTimeRange.value === TIME_RANGE.MONTH.value }" 
            @click="changeTimeRangeAndLog(TIME_RANGE.MONTH.value)">
            {{ $t('DASHBOARD.headerFilter.last30days') }}
          </b-button>
          <b-button 
            :class="{ active: selectedTimeRange.value === TIME_RANGE.CUSTOM.value }" 
            @click="changeTimeRangeAndLog(TIME_RANGE.CUSTOM.value)">
            {{ $t('DASHBOARD.headerFilter.custom') }}
          </b-button>
        </b-button-group>

        <div class="custom-dates">
          <div class="dates-wrapper-dashboard">
            <div class="btn-group">
              <label class="control-label control-label-default">{{ $t('DASHBOARD.headerFilter.from')}}</label>
              <datepicker 
                :value="timeRangeFrom"
                @selected="onFromDateChanged"
                class="datepicker-component"
                :placeholder="$t('DASHBOARD.headerFilter.fromDate')"
                :input-class="'form-control'"
                :calendar-class="'player-datepicker'" />
            </div>
            
            <div class="btn-group">
              <label class="control-label control-label-default">{{ $t('DASHBOARD.headerFilter.to')}}</label>
              <datepicker 
                :value="timeRangeTo"
                @selected="onToDateChanged"
                class="datepicker-component"
                :placeholder="$t('DASHBOARD.headerFilter.toDate')"
                :input-class="'form-control'"
                :calendar-class="'player-datepicker'" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown responsive-filter-dropdown fa-pull-right">
      <a class="filter-link btn btn-transparent-bkg btn-white-text btn-no-border bold ng-scope" role="button" id="dropdownMenuLink" @click="responsiveFilterOpened = !responsiveFilterOpened">
        <img src="@/assets/images/icons/filter-icon.png" alt="filter icon">
        {{ $t('DASHBOARD.headerFilter.filters')}}
      </a>
      
      <div :class="`dropdown-menu filter-dropdown ${responsiveFilterOpened ? 'open' : '' }`">
        <div class="dashboard-header clearfix">
          <div class="filter-part fa-pull-left">
            <label class="control-label control-label-default">
              {{ $t('DASHBOARD.headerFilter.selectTeam')}}
            </label>
            <b-dropdown class="btn-group dropdown dashboard-filter-btn dropdown-btn-group">
              <template slot="button-content">
                <template v-if="selectedEntity === ENTITIES.TEAM && selectedTeam && selectedTeam.teamId">
                  <span class="text-ellipsis-overflow">
                    {{selectedTeam.teamName}}
                  </span>
                </template>
                <template v-if="selectedEntity === ENTITIES.ALL_TEAMS">
                  <span class="text-ellipsis-overflow">
                    {{ $t('DASHBOARD.headerFilter.allTeams')}}
                  </span>
                </template>

                <template v-if="selectedEntity === ENTITIES.INDIVIDUAL">
                  <span class="text-ellipsis-overflow">
                    {{ $t('DASHBOARD.headerFilter.individual')}}
                  </span>
                </template>
              </template>

              <b-dropdown-item
                v-if="teams.length"
                :class="{ active: selectedEntity === ENTITIES.ALL_TEAMS }"
                @click.prevent="selectAllTeams">{{ $t('DASHBOARD.headerFilter.allTeams')}}</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item
                :class="{ active: selectedEntity === ENTITIES.INDIVIDUAL }"
                @click.prevent="selectIndividual">{{ $t('DASHBOARD.headerFilter.individual')}}</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>

              <template v-if="teams.length">
                <b-dropdown-item
                  v-for="(team, i) in teams"
                  :key="i"
                  @click.prevent="onSelectingTeam(team.teamId)"
                  :class="{ active: (selectedEntity === ENTITIES.TEAM && selectedTeam && team.teamId === selectedTeam.teamId) }">

                  <span class="text-ellipsis-overflow">{{team.teamName}}</span>
                </b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
        
          <div :class="`filter-part dates-filter fa-pull-right ${selectedTimeRange.value === TIME_RANGE.CUSTOM.value ? 'custom-dates-selected' : ''}`">
            <b-button-group class="switch-btn-group">
              <b-button 
                :class="{ active: selectedTimeRange.value === TIME_RANGE.SESSION.value }" 
                @click="changeTimeRangeAndLog(TIME_RANGE.SESSION.value)">
                {{ $t('DASHBOARD.headerFilter.lastSession') }}
              </b-button>
              <b-button 
                :class="{ active: selectedTimeRange.value === TIME_RANGE.WEEK.value }" 
                @click="changeTimeRangeAndLog(TIME_RANGE.WEEK.value)">
                {{ $t('DASHBOARD.headerFilter.last7days') }}
              </b-button>
              <b-button 
                :class="{ active: selectedTimeRange.value === TIME_RANGE.MONTH.value }" 
                @click="changeTimeRangeAndLog(TIME_RANGE.MONTH.value)">
                {{ $t('DASHBOARD.headerFilter.last30days') }}
              </b-button>
              <b-button 
                :class="{ active: selectedTimeRange.value === TIME_RANGE.CUSTOM.value }" 
                @click="changeTimeRangeAndLog(TIME_RANGE.CUSTOM.value)">
                {{ $t('DASHBOARD.headerFilter.custom') }}
              </b-button>
            </b-button-group>

            <div class="custom-dates">
              <div class="dates-wrapper-dashboard">
                <div class="btn-group">
                  <label class="control-label control-label-default">{{ $t('DASHBOARD.headerFilter.from')}}</label>
                  <datepicker 
                    :value="timeRangeFrom"
                    @selected="onFromDateChanged"
                    class="datepicker-component"
                    :placeholder="$t('DASHBOARD.headerFilter.fromDate')"
                    :input-class="'form-control'"
                    :calendar-class="'player-datepicker'" />
                </div>
                
                <div class="btn-group">
                  <label class="control-label control-label-default">{{ $t('DASHBOARD.headerFilter.to')}}</label>
                  <datepicker 
                    :value="timeRangeTo"
                    @selected="onToDateChanged"
                    class="datepicker-component"
                    :placeholder="$t('DASHBOARD.headerFilter.toDate')"
                    :input-class="'form-control'"
                    :calendar-class="'player-datepicker'" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TOASTER_ERROR } from '@/common/events.types';
import STATUS_CODES from '@/common/statusCodes';
import { ENTITIES } from '@/constants/DashboardConstants';
import { TIME_RANGE } from '@/constants/DashboardConstants';
import Datepicker from 'vuejs-datepicker'
import { mapGetters, mapActions } from 'vuex';
import { 
  FETCH_PLAYER_TEAMS, 
  CHANGE_SELECTED_ENTITY,
  CHANGE_SELECTED_TEAM,
  CHANGE_TIMERANGE,
  CHANGE_TIMERANGE_TO_DATE,
  CHANGE_TIMERANGE_FROM_DATE,
  DESTROY_ACTIVITY_DATA
} from '@/store/action.types';

export default {
  name: 'HeaderFilter',
  data () {
    return {
      TIME_RANGE: TIME_RANGE,
      ENTITIES: ENTITIES,
      responsiveFilterOpened: false
    }
  },
  computed: {
    ...mapGetters([
      'selectedTeam',
      'teams',
      'account',
      'selectedEntity',
      'selectedTimeRange',
      'timeRangeFrom',
      'timeRangeTo'
    ]),
    displayTimeRangeCalendar () {
      return this.selectedTimeRange.value === TIME_RANGE.CUSTOM.value;
    }
  },
  mounted () {
    if(this.account.playerId)  {
      this.fetchTeamsAction(this.account.playerId);
    }
  },
  methods: {
    ...mapActions({
      fetchTeamsAction: FETCH_PLAYER_TEAMS,
      changeSelectedEntityAction: CHANGE_SELECTED_ENTITY,
      changeSelectedTeamAction: CHANGE_SELECTED_TEAM,
      changeTimeRangeAction: CHANGE_TIMERANGE,
      changeTimerangeToDateAction: CHANGE_TIMERANGE_TO_DATE,
      changeTimerangeFromDateAction: CHANGE_TIMERANGE_FROM_DATE,
      destroyActivityData: DESTROY_ACTIVITY_DATA,
    }),
    onSelectingTeamAndLog (teamId) {
      this.$amplitude.logEvent('pwa: change dashboard team', {selectedTeamType: "TEAM"})
      this.$eventHub.$emit('dashboard-page-updated');
      this.changeSelectedTeamAction(teamId);
      this.responsiveFilterOpened = false;
      this.destroyActivityData();
    },
    selectAllTeamsAndLog () {
      this.$amplitude.logEvent('pwa: change dashboard team', {selectedTeamType: "ALL TEAMS"})
      this.$eventHub.$emit('dashboard-page-updated');
      this.changeSelectedEntityAction(ENTITIES.ALL_TEAMS);
      this.responsiveFilterOpened = false;
      this.destroyActivityData();
    },
    selectIndividualAndLog () {
      this.$amplitude.logEvent('pwa: change dashboard team', {selectedTeamType: "INDIVIDUAL"})
      this.$eventHub.$emit('dashboard-page-updated');
      this.changeSelectedEntityAction(ENTITIES.INDIVIDUAL);
      this.responsiveFilterOpened = false;
      this.destroyActivityData();
    },
    changeTimeRangeAndLog (timeRange) {
      this.$amplitude.logEvent('pwa: change dashboard filter', {timeRange: timeRange})
      this.$eventHub.$emit('dashboard-page-updated');

      if(timeRange === TIME_RANGE.CUSTOM.value) {
        this.changeTimeRangeAction(timeRange);
      } else {
        this.changeTimeRangeAction(timeRange);
        this.changeTimerangeFromDateAction(null);
        this.changeTimerangeToDateAction(null);
        this.responsiveFilterOpened = false;
      }
    },
    onFromDateChanged (date) {
      if(this.timeRangeTo && date > this.timeRangeTo) {
        this.$eventHub.$emit(TOASTER_ERROR, {
          message: this.$t('DASHBOARD.toastMessages.validDateRange')
        });
      } else {
        let amplitudeYear = JSON.stringify(date).substring(1,5)
        let amplitudeMonth = JSON.stringify(date).substring(6,8)
        let amplitudeDay = JSON.stringify(date).substring(9,11)
        let amplitudeDate = `${amplitudeMonth}-${amplitudeDay}-${amplitudeYear}`
        this.$amplitude.logEvent('pwa: change dashboard custom date range', {filterType:"FROM", date: amplitudeDate})
        this.changeTimerangeFromDateAction(date)
          .catch(({ status }) => {
            if(status.code != STATUS_CODES.BP_404) {
              this.$eventHub.$emit(TOASTER_ERROR, {
                message: this.$t('TOAST_MESSAGES.errorTryAgain')
              });
            }
          })
      }

      if(this.timeRangeTo) {
        this.responsiveFilterOpened = false;
      }
    },
    onToDateChanged (date) {
      if(this.timeRangeFrom && date < this.timeRangeFrom) {
        this.$eventHub.$emit(TOASTER_ERROR, {
          message: this.$t('DASHBOARD.toastMessages.validDateRange')
        });
      } else {
        let amplitudeYear = JSON.stringify(date).substring(1,5)
        let amplitudeMonth = JSON.stringify(date).substring(6,8)
        let amplitudeDay = JSON.stringify(date).substring(9,11)
        let amplitudeDate = `${amplitudeMonth}-${amplitudeDay}-${amplitudeYear}`
        this.$amplitude.logEvent('pwa: change dashboard custom date range', {filterType:"TO", date: amplitudeDate})
        this.changeTimerangeToDateAction(date)
          .catch(({ status }) => {
            if(status.code != STATUS_CODES.BP_404) {
              this.$eventHub.$emit(TOASTER_ERROR, {
                message: this.$t('TOAST_MESSAGES.errorTryAgain')
              });
            }
          })
      }

      if(this.timeRangeFrom) {
        this.responsiveFilterOpened = false;
      }
    }
  },
  watch: {
    account (newAccount) {
      this.fetchTeamsAction(newAccount.playerId);
    }
  },
  components: {
    Datepicker
  }
}
</script>

<style lang="scss" scoped>
  .dashboard-header {
    padding-top: 30px;
  }

  .dropdown-btn-group {
    min-width: 300px;

    .btn span {
      line-height: 39px;
    }
  }

  .responsive-filter-dropdown {
    width: 100%;
    display: none;

    .filter-link {
      float: right;
    }
  }

  .custom-dates {
    margin-right: 0;
    margin-left: 20px;
    display: inline-block;
    margin-right: -400px;
    transition: margin .2s;
  }

  .dates-filter {
    overflow: hidden;

    &.custom-dates-selected {
      overflow: visible;

      .custom-dates {
        margin-right: 0;
        transition: margin .2s;
      }
    }
  }

  .dates-wrapper-dashboard {
    .btn-group {
      display: inline-block;
      width: auto;
      max-width: 180px;
      margin-right: 20px;
    }
  }

  .datepicker-component {
    display: inline-block;
  }

  .switch-btn-group {
    margin-top: 30px;
  }


  @media screen and (max-width: 768px) {
    .responsive-filter-dropdown {
      display: block;
    }

    .dashboard-header {
      display: none;

      .filter-part {
        width: 100%;

        .control-label {
          font-size: 14px;
          margin-bottom: 5px;
          margin-top: 10px;
        }
      }
    }

    .switch-btn-group {
      width: 100%;
      display: inline-block;
    }

    .dates-wrapper-dashboard {
      margin-top: 5px;
    }

    .datepicker-component {
      width: 100%;
    }

    .filter-dropdown {
      &.open {
        display: block;
        background-color: #121214;

        .dashboard-header {
          display: block;
        }
      }
    }

    .dates-filter {
      width: 100%;

      .switch-btn-group .btn {
        width: 100%;
      }

      .custom-dates {
        display: none;
      }

      &.custom-dates-selected .custom-dates {
        display: inline-block;
      }
    }

    .dates-wrapper-dashboard {
      width: 100%;
    }

    .custom-dates {
      width: 100%;
      margin-left: 0;

      .btn-group {
        max-width: 999px;
        width: 100%;
        margin-bottom: 20px;

        .player-datepicker {
          right: auto;
        }
      }
    }
  }
</style>

